<template>
  <div class="txt-center">
    <div>
      <img src="/static/images/empty.png" :width="200"  alt="">
    </div>
    <div class="msg_txt">
      {{acceptEmptyData.msg}}
    </div>
  </div>
</template>
<script>
  export default {
    props: ["acceptEmptyData"],
    data() {
      return {}
    }
  }
</script>
<!--css样式-->
<style lang="scss" scoped>
    @import '../../../src/scss/commonH5.scss';
    @import '../../scss/demo.scss';
    .txt-center{
      text-align: center;
    }
    .msg_txt{
      margin-top: 40px;
      font-size: 14px;
      color: #999;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/empty.vue